function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M18,13.5c-1.2,0-2.4-0.2-3.6-0.6c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0-0.5,0.1-0.7,0.3l-2.2,2.2 c-2.8-1.4-5.2-3.8-6.6-6.6l2.2-2.2c0.3-0.3,0.4-0.7,0.2-1C6.7,4.4,6.5,3.2,6.5,2c0-0.5-0.4-1-1-1H2C1.5,1,1,1.4,1,2 c0,9.4,7.6,17,17,17c0.5,0,1-0.5,1-1v-3.5C19,13.9,18.5,13.5,18,13.5z M3,3h1.5C4.6,3.9,4.8,4.7,5,5.6L3.8,6.8C3.4,5.6,3.1,4.3,3,3z  M17,17c-1.3-0.1-2.6-0.3-3.8-0.8l1.2-1.2c0.9,0.2,1.7,0.4,2.6,0.4V17z M16,1h-2h-3v2h3h2h3V1H16z M14.8,4h-1.5H11v2h2.2h1.5H17V4 H14.8z M13.5,7h-1H11v2h1.5h1H15V7H13.5z"
});

var SvgJobFilter = function SvgJobFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/job_filter.84522d69.svg";
export { ForwardRef as ReactComponent };